/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0698fb12&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0698fb12&lang=less&scoped=true"

import exportComponent from "C:\\Users\\10938\\Desktop\\ysjf1\\采购\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0698fb12"]])

export default __exports__